export default function Procedures() {
  const procedures = [
    {
      id: 1,
      title: "Remodelação Glútea",
      description: "Procedimentos estratégicos para melhorar projeção, contorno, sustentação e harmonização corporal com técnica refinada.",
      image: "/img/bb.gif",
      tag: "Destaque",
      items: ["Preenchimento glúteo", "Flacidez", "Celulite", "Assimetrias", "Bioestimulador de colágeno"]
    },
    {
      id: 2,
      title: "Tratamentos para Celulite",
      description: "Tecnologias modernas e protocolos personalizados que ajudam a melhorar a textura da pele e o contorno corporal.",
      icon: "ri-heart-pulse-line",
      num: "02",
      items: ["Celulite grau I ao IV", "Qualidade da pele", "Contorno corporal"]
    },
    {
      id: 3,
      title: "Tratamento para Lipedema",
      description: "Protocolos individualizados para melhora do contorno corporal, redução de medidas e bem-estar da paciente.",
      icon: "ri-body-scan-line",
      num: "03",
      items: []
    },
    {
      id: 4,
      title: "Emagrecimento e Performance",
      description: "Protocolos personalizados para melhora da composição corporal, definição, bem-estar, energia, performance e valorização dos resultados estéticos.",
      icon: "ri-flashlight-line",
      num: "04",
      items: ["Controle metabólico", "Gordura localizada", "Composição corporal"]
    }
  ];

  return (
    <section id="procedimentos" className="bg-white py-20 px-5 sm:px-8 lg:px-16">
      <div className="max-w-5xl mx-auto">

        {/* Header */}
        <div className="flex items-center gap-3 mb-10">
          <div className="w-8 h-px bg-[#C9A84C]"></div>
          <span className="text-[#C9A84C] text-xs tracking-[0.25em] uppercase font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Procedimentos
          </span>
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a1a] mb-12 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          Especialidades<br />
          <span className="italic text-[#C9A84C]">Exclusivas</span>
        </h2>

        {/* Featured card */}
        <div className="relative rounded-3xl overflow-hidden mb-5 cursor-pointer group shadow-xl" style={{ minHeight: '420px' }}>
          <div className="w-full" style={{ height: '420px' }}>
            <img
              src={procedures[0].image}
              alt={procedures[0].title}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

          <div className="absolute top-5 left-5">
            <span className="bg-[#C9A84C] text-white text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full shadow-md" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              {procedures[0].tag}
            </span>
          </div>

          <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">
            <p className="text-[#C9A84C] text-xs tracking-widest uppercase mb-2 font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>01</p>
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              {procedures[0].title}
            </h3>
            <p className="text-white/80 text-sm leading-relaxed mb-3" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              {procedures[0].description}
            </p>
            <div className="flex flex-wrap gap-1.5">
              {procedures[0].items.map((item) => (
                <span key={item} className="bg-white/15 backdrop-blur-sm text-white/90 text-xs px-2.5 py-1 rounded-full border border-white/20" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Other procedures */}
        <div className="flex flex-col gap-3">
          {procedures.slice(1).map((proc) => (
            <div
              key={proc.id}
              className="flex items-center gap-5 bg-[#faf8f5] border border-[#e8dfc8] rounded-2xl px-5 py-5 hover:border-[#C9A84C]/60 hover:bg-[#fdf9f0] hover:shadow-md transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#C9A84C]/10 flex-shrink-0">
                <i className={`${proc.icon} text-[#C9A84C] text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[#C9A84C] text-xs font-semibold mb-0.5" style={{ fontFamily: 'DM Sans, sans-serif' }}>{proc.num}</p>
                <h3 className="text-[#1a1a1a] text-base font-semibold mb-1 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {proc.title}
                </h3>
                <p className="text-[#888] text-xs leading-relaxed mb-2" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                  {proc.description}
                </p>
                {proc.items && proc.items.length > 0 && (
                  <div className="flex flex-wrap gap-1">
                    {proc.items.map((item) => (
                      <span key={item} className="bg-[#C9A84C]/10 text-[#8B6914] text-xs px-2 py-0.5 rounded-full" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                        {item}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-line text-[#C9A84C] text-lg"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
